// Bedienungsanleitung — strukturierter Content für das HelpModal.
// Jede Phase kann hier einen Eintrag hinzufügen / erweitern, ohne die UI
// anzufassen. Sektionen die noch nicht implementiert sind setzen
// `comingSoon: true` und werden mit dem 🔜-Hinweis gerendert.

export const HELP_TOPICS = [
  {
    id: "erste-schritte",
    title: "Erste Schritte",
    body: [
      {
        kind: "p",
        text:
          "Willkommen auf deiner eigenen 360°-Video-Plattform. Hier kannst du echte 360°-Videos hochladen, schneiden, mit Übergängen versehen und per Link teilen.",
      },
      {
        kind: "actions",
        items: [
          { label: "Video hochladen", href: "/admin/upload" },
          { label: "Bibliothek öffnen", href: "/admin" },
        ],
      },
      {
        kind: "tip",
        text:
          'Ab Phase 11 gibt es EINE zentrale Bearbeitungsseite pro Video: Klicke in der Bibliothek auf „Bearbeiten". Oben findest du Video-Daten (Titel/Slug/Beschreibung/Sichtbarkeit), Text-Einblendungen und Schau-hier-hin-Pfeile — darunter den Editor (Clips, Übergänge, Musik, Titelkarten).',
      },
    ],
  },
  {
    id: "hochladen",
    title: "Videos hochladen",
    body: [
      {
        kind: "p",
        text:
          "Klick oben auf 'Upload'. Ziehe deine 360°-MP4-Datei in das gestrichelte Feld oder wähle sie per Klick aus. Trage Titel und ggf. Beschreibung ein. Klick auf 'Hochladen'.",
      },
      {
        kind: "tip",
        text:
          "Falls die Verbindung mal abbricht: einfach dieselbe Datei nochmal auswählen — der Upload setzt automatisch an der Stelle fort, wo er stehen geblieben ist.",
      },
    ],
  },
  {
    id: "bearbeiten",
    title: "Videos bearbeiten",
    badge: "NEU",
    body: [
      {
        kind: "p",
        text:
          'Ab Phase 11 gibt es EINE zentrale Bearbeitungs-Seite pro Video (kein Popup mehr). Klick in der Bibliothek auf „Bearbeiten" — die Seite ist in zwei Bereiche geteilt:',
      },
      {
        kind: "list",
        items: [
          {
            label: "Oben: Video-Daten & Player-Features",
            text:
              'Drei Tabs — „Info" (Titel, Link-Name, Beschreibung, Sichtbarkeit), „Text" (Text-Einblendungen für den Player) und „Pfeile" (Schau-hier-hin-Pfeile). Eigener „Video-Daten speichern"-Knopf.',
          },
          {
            label: "Unten: Projekt-Editor",
            text:
              'Deine Timeline mit Clips, Übergängen, Musik und Titelkarten. Eigener „Projekt speichern"-Knopf ganz unten.',
          },
        ],
      },
      {
        kind: "p",
        text:
          'Clips ordnest du per Drag-and-Drop in der Timeline an. Pro Clip kannst du Anfang und Ende setzen — entweder mit dem Schieberegler rechts oder direkt im Player über „Anfang hier" / „Ende hier".',
      },
      {
        kind: "tip",
        text:
          "Zwei Speichern-Knöpfe = zwei Bereiche: Video-Daten (oben) sind Metadaten die im Player-Overlay erscheinen. Projekt-Speichern (unten) betrifft nur das Bearbeitungs-Projekt. Beide funktionieren unabhängig.",
      },
    ],
  },
  {
    id: "uebergaenge",
    title: "Übergänge zwischen Clips",
    badge: "NEU",
    body: [
      {
        kind: "p",
        text:
          "Zwischen jedem Clip-Paar findest du in der Timeline ein kleines Übergangs-Feld. Klick darauf und wähle einen Effekt:",
      },
      {
        kind: "list",
        items: [
          {
            label: "Sanft überblenden",
            text: "Clip A blendet weich in Clip B über. Perfekt für ruhige Stimmung.",
          },
          {
            label: "Schwarzblende",
            text:
              "Clip A wird kurz schwarz, dann erscheint Clip B. Wirkt wie ein neuer Tag oder eine neue Szene.",
          },
          {
            label: "Weißblende",
            text: "Wie die Schwarzblende, aber mit Weiß. Passt zu sonnigen Urlaubsbildern.",
          },
        ],
      },
      {
        kind: "p",
        text:
          "Mit dem Schieberegler darunter stellst du ein, wie lange der Übergang dauert (zwischen einer halben und zwei Sekunden, Standard ist eine Sekunde).",
      },
      {
        kind: "tip",
        text:
          "Probier 'Sanft überblenden' mit 1 Sekunde — funktioniert für 90 % der Urlaubsvideos.",
      },
    ],
  },
  {
    id: "musik",
    title: "Musik unterlegen",
    badge: "NEU",
    body: [
      {
        kind: "p",
        text:
          "Du kannst deine eigene Hintergrundmusik (z. B. mit Suno generierte Tracks) in deine persönliche Bibliothek hochladen und sie pro Projekt einsetzen.",
      },
      {
        kind: "list",
        items: [
          {
            label: "Bibliothek anlegen",
            text:
              'Oben unter „Musik" lädst du MP3-/M4A-/WAV-Dateien hoch. Pro Track kannst du Titel, Künstler und Stimmungs-Tags (z. B. „chill, ukulele, strand") hinterlegen.',
          },
          {
            label: "Track im Editor wählen",
            text:
              'Im Bereich „Musik" unter der Timeline wählst du einen Track aus, regelst die Lautstärke und entscheidest, wie sanft die Musik ein- und ausblendet.',
          },
          {
            label: "Original-Ton bleibt erhalten",
            text:
              'Mit „Original-Ton automatisch leiser machen wenn jemand spricht" duckt die Plattform die Musik automatisch ab, sobald Original-Audio anliegt.',
          },
        ],
      },
      {
        kind: "tip",
        text:
          'Mit Stimmungs-Tags pro Track UND pro Clip kann die Plattform automatisch passende Musik vorschlagen — siehe Button „Musik automatisch zuordnen".',
      },
      {
        kind: "tip",
        text:
          'Keine eigene Musik? Klick auf „Suno-Prompts vorschlagen" — wir bauen drei fertige Text-Vorlagen, die du in Suno einfügen und die generierte MP3 wieder hier hochladen kannst.',
      },
    ],
  },
  {
    id: "titelkarten",
    title: "Titelkarten",
    badge: "NEU",
    body: [
      {
        kind: "p",
        text:
          "Du kannst deinem Video einen Anfang (Intro), Kapitel-Trenner und ein Ende (Outro) geben — alles mit eigenem Titel, Untertitel und Animation.",
      },
      {
        kind: "list",
        items: [
          {
            label: "Intro",
            text:
              'Erscheint vor allen Clips. Perfekt für „Test-Urlaub 2026" oder den Reise-Titel.',
          },
          {
            label: "Kapitel",
            text:
              'Wird zwischen zwei Clips eingefügt — z. B. „Tag 2 — Strand".',
          },
          {
            label: "Outro",
            text:
              'Schließt das Video ab. Z. B. „Danke fürs Mitreisen 🌴".',
          },
        ],
      },
      {
        kind: "p",
        text:
          'Pro Karte stellst du ein: Titel, Untertitel (optional), Dauer (1–10 Sek), Hintergrundfarbe, Textfarbe, Schriftgröße (Klein / Mittel / Groß) und Animation (Sanft, Hineinwischen oder Heranzoomen).',
      },
      {
        kind: "tip",
        text:
          'Für Urlaubsvideos passt schwarzer Hintergrund mit weißer Schrift und „Sanft einblenden" am besten — drei Sekunden sind die perfekte Lese-Dauer.',
      },
    ],
  },
  {
    id: "player",
    title: "Player-Features",
    badge: "NEU",
    body: [
      {
        kind: "p",
        text:
          "Im Player gibt es Helfer, die du pro Video aktivieren kannst — sie werden nicht ins MP4 gebrannt, sondern als sanfte Einblendung über dem 360°-Bild gezeigt:",
      },
      {
        kind: "list",
        items: [
          {
            label: "Text-Einblendungen",
            text:
              'Beliebig viele freie Texte mit eigener Zeit, Dauer und Position. Zwei Stile: „Mit Hintergrund" (semi-transparente Box, gut bei stark wechselnden Hintergründen) oder „Nur Text" mit dezentem Schatten (eleganter Look wie Apple-Videos / GoPro-Edits). Pro Eintrag wählbar: Position (6 Optionen), Schriftgröße (Klein / Mittel / Groß) und Textfarbe.',
          },
          {
            label: "Schau-hier-hin-Pfeile",
            text:
              'Hilft Zuschauern wichtige Momente in 360° zu finden. Wenn der Gast nicht in die richtige Richtung schaut, erscheint ein dezenter Pfeil, der die Blickrichtung anzeigt — verschwindet, sobald er hinschaut. Ein Tap auf den Pfeil dreht die Ansicht smooth (~1 Sek) zum Ziel. Beim ersten Pfeil eines Gastes zeigen wir einmalig einen Mini-Hinweis „Antippen oder selbst drehen" — danach nie wieder.',
          },
          {
            label: "Zurück-zur-Bibliothek-Knopf",
            text:
              'Wenn du eingeloggt bist, siehst du im Player oben links einen Pfeil „Zur Bibliothek". Gäste ohne Login sehen ihn nicht — der Player wirkt für sie wie eine öffentliche Seite.',
          },
        ],
      },
      {
        kind: "p",
        text:
          'Text-Einblendungen und Pfeile findest du in der Bearbeiten-Seite oben unter den Tabs „Text" und „Pfeile".',
      },
      {
        kind: "tip",
        text:
          "Maximal 1-2 Text-Einblendungen gleichzeitig anzeigen lassen, sonst wird's voll. Halte den Text kurz (1-2 Zeilen). Pfeile nicht zu häufig verwenden — 1-3 pro Video reichen. Yaw 0° = vorne, 90° = rechts, −90° = links, ±180° = hinten.",
      },
    ],
  },
  {
    id: "teilen",
    title: "Teilen & Links",
    body: [
      {
        kind: "p",
        text:
          "Jedes Video bekommt einen eigenen Link, z. B. /v/strand-bali. Im Player findest du drei Buttons: Link kopieren, per WhatsApp teilen, QR-Code anzeigen.",
      },
      {
        kind: "p",
        text:
          "Du kannst den Link direkt verschicken — der Empfänger braucht nichts zu installieren und sieht das Video sofort im Browser in 360°.",
      },
      {
        kind: "tip",
        text:
          'Damit WhatsApp und iMessage eine schöne Vorschau-Karte mit Titel + Beschreibung + Bild zeigen: trage in der Bearbeiten-Seite unter „Info" eine Beschreibung ein (2-3 Sätze reichen). Ohne Beschreibung nimmt die Plattform automatisch einen freundlichen 360°-Standardtext.',
      },
    ],
  },
  {
    id: "faq",
    title: "Häufige Fragen",
    body: [
      {
        kind: "qa",
        q: "Ist mein Video wirklich 360°?",
        a:
          "Wenn beim Upload eine Warnung erscheint, ist es vermutlich ein normales Video. Die Plattform zeigt 360° nur dann korrekt, wenn es eine echte equirectangulare MP4-Datei ist (Bildverhältnis 2:1).",
      },
      {
        kind: "qa",
        q: "Welche Browser werden unterstützt?",
        a:
          "Chrome, Edge, Safari und Firefox auf dem Desktop. Auf dem Smartphone funktioniert die Handybewegung am besten in Chrome und Safari.",
      },
      {
        kind: "qa",
        q: "Was passiert, wenn mein Upload abbricht?",
        a:
          "Die Plattform merkt sich den Fortschritt automatisch. Wähl die Datei einfach noch einmal aus — der Upload setzt da fort, wo er abgebrochen ist.",
      },
    ],
  },
];
